
    <!-- Filter -->
    <mat-card class="filter">

        <label>Starred</label>
  
        <div class="slAct">
          <!-- <ng-container >
            <button mat-icon-button>
              <mat-icon>grade</mat-icon>
            </button>
            <button mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container> -->
        </div>
  
  
        <mat-form-field appearance="fill">
          <mat-label>Search file here...</mat-label>
          <input matInput type="text"  maxlength="30">
        </mat-form-field>
  
  
        <!-- <button class="filterbtn" mat-icon-button>
          <mat-icon>filter_list</mat-icon>
        </button> -->
<!--   
        <div class="add">
          <button class="create" [matMenuTriggerFor]="menu" mat-flat-button color="primary">
            Create
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="openCreateFolderDialogue(createFileManagerFolder)">
              <mat-icon>folder</mat-icon> New Folder
            </button>
            <input #Input hidden="true" type="file"  (change)="handleFileInput($event.target.files)">
            <button mat-menu-item (click)="Input.click()">            
              <mat-icon>upload_file</mat-icon> Upload File
            </button>
          </mat-menu>
        </div> -->
  
  
      </mat-card>
  
      <!-- Filter -->

<p>starred works!</p>
